import { Component } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent {

  constructor(public readonly toastController: ToastController, private translate: TranslateService) { }

  async errorToast(message = 'operation_denied') {
    const toast = await this.toastController.create({
      message: await this.translate.get(message).toPromise(),
      duration: 4000,
      position: 'top',
      cssClass: ['toast', 'error']
    });
    await toast.present();
 }

  async successToast(message = 'operation_successfull') {
    const toast = await this.toastController.create({
      message: await this.translate.get(message).toPromise(),
      duration: 5000,
      position: 'top',
      cssClass: ['toast', 'success']
    });
    await toast.present();
  }

  async infoToast(message: string) {
    const toast = await this.toastController.create({
      message: await this.translate.get(message).toPromise(),
      duration: 4000,
      position: 'top',
      cssClass: ['toast', 'info']
    });
    await toast.present();
  }
}
